<template>
  <div>
    <div class="back" @click="goBack">&lt; 返 回</div>
    <div class="common-style assemblyPage">
      <div class="ass-box">
        <p class="title">
          <a-popover title="请输入标题" trigger="click" placement="bottom">
            <template slot="content">
              <a-input @blur="changeTitle(formData.exercisename)" v-model="formData.exercisename"></a-input>
            </template>
            <span>
              {{
              formData.exercisename ? formData.exercisename : "请输入作业标题"
              }}
            </span>
          </a-popover>
        </p>

        <ul id="svgBox">
          <draggable group="people" :list="pageList" @change="move($event, true)">
            <li v-for="(item, index) in pageList" :key="index">
              <!-- <p class="sq-num">{{(index + 1)+'.'}}</p> -->
              <div @click="lookAnswer(item,index)">
                <div class="topic" v-html="item.stem"></div>
                <div class="answer" v-show="item.showAnswer">
                  <p>
                    【答案】
                    <span v-if="currQuesAnswer.answer" v-html="currQuesAnswer.answer"></span>
                    <span v-else>无</span>
                  </p>
                  <p>
                    【解析】
                    <span v-if="currQuesAnswer.explanation" v-html="currQuesAnswer.explanation"></span>
                    <span v-else>无</span>
                  </p>
                </div>
                <div class="info">
                  <p v-if="item.knowledgePoints">【考察】{{ item.knowledgePoints }}</p>
                  <p>
                    【题型】{{ item.questionTypeName }}
                    <i>|</i>
                    {{
                    item.experiencedDifficulty == "VERY_EASY"
                    ? "容易"
                    : item.experiencedDifficulty == "EASY"
                    ? "较易"
                    : item.experiencedDifficulty == "MODERATE"
                    ? "中等"
                    : item.experiencedDifficulty == "HARD"
                    ? "较难"
                    : item.experiencedDifficulty == "VERY_HARD"
                    ? "困难"
                    : "未设置"
                    }}
                    <i>|</i>
                    题号：{{ item.questionId }}
                  </p>
                </div>
                <div :id="'svgBox' + item.questionId" :style="{ height: item.blankHeight + 'px' }"></div>
              </div>
              <div class="toolbar">
                <!-- <a v-if="state=='true'">设为例题</a> -->
                <!-- <a>设置分值<input @blur="changeNum(item)" type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model="item.score">分</a> -->
                <a @click="moveUp(item, index)">上移</a>
                <a @click="moveDown(item, index)">下移</a>
                <a @click="DelQues(item)">删除</a>
                <a @click="lookAnswer(item,index)">
                  {{
                  item.showAnswer ? "隐藏答案" : "查看答案"
                  }}
                </a>
                <a-button
                  class="scrollLine"
                  :id="'svgResize' + item.questionId"
                  @mousedown="
                    dragHeight($event, item.questionId, item.blankHeight)
                  "
                  size="small"
                  icon="caret-down"
                ></a-button>
              </div>
            </li>
          </draggable>
        </ul>
        <nav class="menu">
          <input type="checkbox" href="#" class="menu-open" name="menu-open" id="menu-open" />
          <label class="menu-open-button" for="menu-open">
            <span class="hamburger hamburger-1"></span>
            <span class="hamburger hamburger-2"></span>
            <span class="hamburger hamburger-3"></span>
          </label>

          <a-tooltip placement="right">
            <a-dropdown
              placement="topCenter"
              arrowPointAtCenter
              overlayClassName="dropdownDownload"
            >
              <a class="menu-item">
                <a-icon type="download" />
              </a>
              <a-menu slot="overlay" @click="openDownload($event)">
                <a-menu-item key="1">
                  <a-icon type="check-circle" style="vertical-align: text-top;" />含答案下载
                </a-menu-item>
                <a-menu-item key="2">
                  <a-icon type="close-circle" style="vertical-align: text-top;" />不含答案下载
                </a-menu-item>
                <a-menu-item key="3">
                  <a-icon type="book" />试卷下载
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>发布作业</span>
            </template>
            <a class="menu-item" @click="openPublishDialog">
              <a-icon type="exception" />
            </a>
          </a-tooltip>
          <a-tooltip placement="right">
            <template slot="title">
              <span>暂存作业</span>
            </template>
            <a class="menu-item" @click="openDraftsWork">
              <a-icon type="diff" />
            </a>
          </a-tooltip>

          <a-tooltip placement="left">
            <template slot="title">
              <span>重置</span>
            </template>
            <a class="menu-item" @click="ResetAssembly">
              <a-icon type="reload" />
            </a>
          </a-tooltip>
        </nav>
      </div>

      <a-modal title="分值设置" v-model="dialog.setVisible" :footer="null">
        <setScore :pageList="pageList" v-if="dialog.setVisible" v-on:incre="closeSetVisible"></setScore>
      </a-modal>

      <a-modal title="统计分析" v-model="dialog.viewChartVisible" cancelText="取消" okText="确定">
        <viewChart v-if="dialog.viewChartVisible" v-on:incre="closeViewChartVisible"></viewChart>
      </a-modal>

      <a-modal
        width="850px"
        title="发布作业"
        v-model="dialog.publishVisible"
        @cancel="handleCancel"
        @ok="checkPublish"
        cancelText="取消"
        okText="确认"
        :bodyStyle="{
        overflow:'auto'
      }"
        centered
      >
        <publishAssembly
          ref="publishAssembly"
          :formData="formData"
          :pageList="pageList"
          :exercisetypeData="exercisetypeData"
          v-if="dialog.publishVisible"
          v-on:incre="closePublishDialog"
        ></publishAssembly>
      </a-modal>

      <a-modal title="发布课堂互动" v-model="dialog.classVisible" :footer="null">
        <publishClass v-if="dialog.classVisible" v-on:incre="closeClasshDialog"></publishClass>
      </a-modal>

      <a-modal title="暂存作业至草稿箱" v-model="dialog.draftsWorkVisible" :footer="null">
        <staging-job v-if="dialog.draftsWorkVisible" v-on:incre="closeDraftsWork"></staging-job>
      </a-modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import setScore from "../testAssembly/model/setScore";
import viewChart from "../testAssembly/model/viewChart";
import publishAssembly from "../testAssembly/model/publish-Assembly";
import publishClass from "../testAssembly/model/publish-Class";
import stagingJob from "../testAssembly/model/staging-job";
import data from "../../../src/config/assemblyJson.js";
import draggable from "vuedraggable";
export default {
  name: "assembly",
  components: {
    draggable,
    setScore,
    viewChart,
    publishAssembly,
    publishClass,
    stagingJob,
  },
  inject: ["reload"],
  data () {
    let data = data;
    return {
      formData: {
        id: 0, // 当前作业id，未发布的id为0，
        exercisetype: '4', // 作业类型 (课前导学...)
        exercisename: "请输入作业标题", // 作业标题
        exercisenote: "", // 作业备注
        execisepushtime: moment().format("YYYY-MM-DD HH:mm:ss"), // 发布时间
        execiseendtime: moment()
          .add(1, "days")
          .format("YYYY-MM-DD HH:mm:ss"), // 截止时间
        completiontime: "60", // 预估完成作业时间
        classids: [], // 班级id集合
        studentids: [], //学生id集合
        classstudentids: [], // 班级学生id集合
        quesids: [], // 题目id集合
        bankid: "", // 学科id
        struct: {}, // 整个作业json
        totalscore: 0, // 总分
      },
      moment,
      state: "",
      localJson: [], // 页面传值
      localData: "", // 获取题目数据id
      quesData: [], // 题目数据
      title: "请输入作业标题", // 页面显示title
      pageList: [], // 页面题目数据
      quesAnswerList: [],//试题答案列表
      currQuesAnswer: [], //查看答案
      exercisetypeData: [], // 作业类型
      dialog: {
        // 控制弹框显示
        setVisible: false,
        viewChartVisible: false,
        typeData: [],
        viewChartData: [],
        publishVisible: false,
        classVisible: false,
        draftsWorkVisible: false,
      },
    };
  },
  methods: {
    // 作业类型
    getWorktype () {
      this.$http
        .get("v1/learnonly/getExercisesQuestions/getExerciseType")
        .then((response) => {
          let exercisetypeData = response.data.data
          for (let i = 0; i < Object.keys(exercisetypeData).length; i++) {
            // console.log(exercisetypeData[Object.keys(exercisetypeData)[i]]);
            this.exercisetypeData.push({
              id: Object.keys(exercisetypeData)[i],
              name: exercisetypeData[Object.keys(exercisetypeData)[i]]
            })
          }
        })
    },

    getQuesData () {
      //   debugger
      this.$http
        .post("v1/learnonly/zj/paper/loadques/sort", {
          data: this.localData,
        })
        .then((response) => {
          console.log(response);
          if (response.status === 200 && response.data !== null) {
            var data = response.data;
            for (let i = 0; i < data.length; i++) {
              var item = data[i];
              item.showAnswer = false; // 添加默认不展示答案属性
              item.index = Number(i) + 1;
              item.score = "5";
              if (this.pageList.length > 0) {
                this.pageList.forEach((item2) => {
                  if (item2.questionId === item.sid) {
                    item.blankHeight = item2.blankHeight;
                  }
                });
              } else {
                item.blankHeight = 0; // 添加默认留白为0属性
              }
            }

            this.quesAnswerList = []

            this.quesData = (data.length == 0) ? [] : data.sort((a, b) => {
              return parseFloat(a.index) - parseFloat(b.index);
            });
            this.setpageList();
          } else {
            this.$message.error("暂无试题或获取题目失败");
          }
        });
    },
    setpageList () {
      this.pageList = [];
      console.log(this.quesData);
      this.quesData.forEach((q) => {
        var obj = {
          questionId: q.sid,
          bankId: q.bankId,
          bankName: q.bankName,
          childNum: q.childNum,
          questionTypeId: q.typeId,
          questionTypeName: q.typeName,
          blankHeight: q.blankHeight,
          score: q.score,
          tip: "",
          mark: 0,
          tag: 0,
          stem: q.stem,
          knowledgePoints: q.knowledgePoints,
          experiencedDifficulty: q.experiencedDifficulty,
          index: q.index,
          showAnswer: q.showAnswer,
          questNumName: q.questNumName
        };
        this.pageList.push(obj);
      });
      console.log(this.pageList);
      var data = JSON.stringify(this.pageList);
      localStorage.setItem("pageList", data);
      this.totalizeScore(this.pageList);
      this.getQuesId(this.pageList);
      if (this.pageList.length > 0) {
        this.formData.bankid = this.pageList[0].bankId;
      }
      this.formData.struct.title = this.formData.exercisename;
    },
    // 修改试卷标题
    changeTitle (title) {
      localStorage.setItem("Title", title);
    },
    changeNum () {
      var data = JSON.stringify(this.pageList);
      localStorage.setItem("pageList", data);
      this.totalizeScore(this.pageList);
    },
    totalizeScore (data) {
      var totalScore = 0;
      data.forEach((i) => {
        totalScore = totalScore + parseFloat(i.score);
      });
      this.formData.totalscore = totalScore;
    },
    moveUp (item, index) {
      if (index === 0) {
        this.$message.warning("当前已是第一题");
      } else {
        this.move(1, false, item, index, "up");
      }
    },
    moveDown (item, index) {
      if (index === this.pageList.length - 1) {
        this.$message.warning("当前已是最后一题");
      } else {
        this.move(1, false, item, index, "down");
      }
    },
    move (event, istrue, item, index, flag) {
      if (istrue === false) {
        // 移动DOM元素
        var objQues = this.pageList.splice(index, 1);
        var objAnswer = this.quesAnswerList.splice(index, 1)
        if (flag === "up") {
          this.pageList.splice(index - 1, 0, ...objQues);
          this.quesAnswerList.splice(index - 1, 0, ...objAnswer)
        } else {
          this.pageList.splice(index + 1, 0, ...objQues);
          this.quesAnswerList.splice(index + 1, 0, ...objAnswer)
        }
        // 重排localData里的数据
        //   var arr = this.localData.split(',')
        //   for (let l = 0; l < arr.length; l++) {
        //     if (arr[l] === item.questionId) {
        //       var x = arr.splice(l, 1)
        //       if (flag === 'up') {
        //         arr.splice(l - 1, 0, ...x)
        //       } else {
        //         arr.splice(l + 1, 0, ...x)
        //       }
        //       break
        //     }
        //   }
        //   localStorage.setItem('localData', arr)
        //   this.localData = localStorage.getItem('localData')
      }
      this.getQuesId(this.pageList);
      // 重排localData里的数据
      localStorage.removeItem("localData");
      localStorage.removeItem("localJson");
      var dataArr = [];
      var jsonArr = [];
      for (let i = 0; i < this.pageList.length; i++) {
        dataArr.push(this.pageList[i].questionId);
        jsonArr.push({
          bankName: this.pageList[i].bankName,
          questionId: this.pageList[i].questionId,
          childNum: this.pageList[i].childNum,
          typeName: this.pageList[i].questionTypeName,
        });
      }
      console.log(jsonArr);
      localStorage.setItem("localData", dataArr);
      this.localData = localStorage.getItem("localData");
      this.getQuesData()
      localStorage.setItem("localJson", JSON.stringify(jsonArr));
      this.localJson = JSON.parse(localStorage.getItem("localJson"));
    },
    // 设置试题id
    getQuesId (data) {
      var quesIds = [];
      data.forEach((i) => {
        quesIds.push(i.questionId);
      });
      this.formData.quesids = quesIds;
    },
    // 拖拽高度
    dragHeight (ev, id, height) {
      var svgResize = document.getElementById("svgResize" + id);
      var svgBox = document.getElementById("svgBox" + id);
      var blankHeight = "";
      var that = this;
      svgResize.onmousedown = function (e) {
        var startY = e.clientY;
        svgResize.top = svgResize.offsetTop;

        document.onmousemove = function (e) {
          var endY = e.clientY;
          var moveLen = svgResize.top + (endY - startY);
          blankHeight = moveLen + height;
          if (blankHeight < 0) {
            blankHeight = 0;
          }
          svgBox.style.height = blankHeight + "px";
          that.pageList.forEach((b) => {
            if (b.questionId == id) {
              b.blankHeight = blankHeight;
            }
          });
          var data = JSON.stringify(that.pageList);
          localStorage.setItem("pageList", data);
        };
        document.onmouseup = function (evt) {
          if (evt.isTrusted) {
            document.onmousemove = null;
            document.onmouseup = null;
            svgResize.releaseCapture && svgResize.releaseCapture();
          }
        };
        svgResize.setCapture && svgResize.setCapture();
        return false;
      };
    },
    DelQues (item) {
      var that = this;
      this.$confirm({
        title: "确认删除该试题吗?",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk () {
          var arr = that.localData.split(",");
          var index = arr.indexOf(item.questionId);
          if (index > -1) {
            arr.splice(index, 1);
          }
          that.localData = arr.join(",");
          localStorage.setItem("localData", that.localData);
          for (var i = 0; i < that.pageList.length; i++) {
            if (that.pageList[i].questionId === item.questionId) {
              that.pageList.splice(i, 1);
            }
          }
          for (let j in that.pageList) {
            that.pageList[j].index = j;
          }
          localStorage.setItem(
            "pageList",
            JSON.stringify(that.pageList)
          );
          var quesStructures = JSON.parse(
            localStorage.getItem("localJson")
          );
          for (let k = 0; k < quesStructures.length; k++) {
            if (item.questionId == quesStructures[k].questionId) {
              quesStructures.splice(k, 1);
              localStorage.setItem(
                "localJson",
                JSON.stringify(quesStructures)
              );
            }
          }
          that.totalizeScore(that.pageList);
          that.getQuesId(that.pageList);
          that.$message.success("删除成功");
        },
      });
    },

    async lookAnswer (item, index) {

      if (!this.quesAnswerList[index]) {
        var res = await this.$http.get(
          `v1/learnonly/zj/question/answer?questionid=${item.questionId}`
        )
        this.quesAnswerList[index] = {
          answer: res.data.answer,
          explanation: res.data.explanation,
        }
      }

      if (item.showAnswer === false || item.showAnswer === undefined) {
        for (let i = 0; i < this.pageList.length; i++) {
          this.pageList[i].showAnswer = false
        }
        item.showAnswer = true
        this.currQuesAnswer = this.quesAnswerList[index]
      } else {
        item.showAnswer = false
        this.currQuesAnswer = {}
      }


      // this.$http
      //   .get("v1/learnonly/zj/question/answer", {
      //     params: { questionid: item.questionId },
      //   })
      //   .then((response) => {
      //     this.answerList = response.data;
      //     for (let i = 0; i < this.pageList.length; i++) {
      //       if (this.pageList[i].questionId == item.questionId) {
      //         this.pageList[i].showAnswer =
      //           !this.pageList[i].showAnswer;
      //       } else {
      //         this.pageList[i].showAnswer = false;
      //       }
      //     }
      //   });
    },
    // 保存（暂时不用）
    // saveAssembly () {
    //     var paraArr = []
    //     this.pageList.forEach(p => {
    //         var paraObj = {
    //             questionId: p.questionId,
    //             bankId: p.bankId,
    //             bankName: p.bankName,
    //             childNum: p.childNum,
    //             questionTypeId: p.questionTypeId,
    //             questionTypeName: p.questionTypeName,
    //             blankHeight: p.blankHeight,
    //             score: p.score,
    //             tip: "",
    //             mark: 0,
    //             tag: 0,
    //         }
    //         paraArr.push(paraObj)
    //     })
    //     this.formData.struct.partStructures[0].sectionStructures[0].quesStructures = paraArr
    //     this.formData.struct.title = this.title
    //     var params = {
    //         data: JSON.stringify(this.formData.struct),
    //         bankid: this.pageList[0].bankId
    //     }
    //     this.$http.post('v1/learnonly/zj/paper/save', params).then(response => {
    //         console.log('保存成功', response)
    //     })
    // },
    // 发布弹框
    openPublishDialog () {
      if (this.$store.getters.classMasterInfoList.length === 0)
        return this.$message.warning("暂未绑定班级,无法发布作业！", 1);
      this.dialog.publishVisible = true;
    },
    closePublishDialog () {
      this.dialog.publishVisible = false;
    },
    handleCancel () {
      this.reload();
    },
    checkPublish () {
      this.$refs.publishAssembly.checkPublish() // 父组件调用子组件的方法
    },
    // 下载
    openDownload (e) {
      this.formData.struct.partStructures[0].sectionStructures[0].quesStructures =
        [];
      this.pageList.forEach((q) => {
        var obj = {
          questionId: q.questionId,
          bankId: q.bankId,
          bankName: q.bankName,
          childNum: q.childNum,
          questionTypeId: q.questionTypeId,
          questionTypeName: q.questionTypeName,
          blankHeight: q.blankHeight,
          score: q.score,
          tip: q.tip,
          mark: q.mark,
        };
        this.formData.struct.partStructures[0].sectionStructures[0].quesStructures.push(
          obj
        );
      });
      if (localStorage.getItem("Title")) {
        this.formData.struct.title = localStorage.getItem("Title");
      } else {
        this.formData.struct.title = this.formData.exercisename;
      }
      this.formData.struct.totalScore = this.formData.totalscore;
      // 是否包含答案下载
      if (e.key == 1) {
        this.formData.struct.includeAnswer = true;
        this.$nextTick(() => {
          this.downloadLink();
        });
      } else if (e.key == 2) {
        this.formData.struct.includeAnswer = false;
        this.$nextTick(() => {
          this.downloadLink();
        });
      } else {
        this.$router.push({
          path: "/works/paper",
          query: {
            data: JSON.stringify(
              this.formData.struct.partStructures[0]
                .sectionStructures[0].quesStructures
            ),
            title: this.formData.exercisename,
            type: 2,
          },
        });
      }
    },
    downloadLink () {
      this.$http
        .post("v1/learnonly/getExercisesQuestions/generateWordPage", {
          struct: JSON.stringify(this.formData.struct),
          type: "docx",
        })
        .then((res) => {
          if (res.data.code == 200) {
            window.open(res.data.data);
            // this.$nextTick(() => {
            //     this.$message.success("下载成功");
            // })
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 草稿作业发布弹框
    openDraftsWork () {
      this.dialog.draftsWorkVisible = true;
      console.log(this.formData);
    },
    closeDraftsWork () {
      this.dialog.draftsWorkVisible = false;
    },
    // 课堂互动发布弹框
    openClassDialog () {
      this.dialog.classVisible = true;
    },
    closeClasshDialog () {
      this.dialog.classVisible = false;
    },
    // 设置分值弹框
    // openSetDialog() {
    //   this.dialog.setVisible = true
    // },
    closeSetVisible () {
      this.dialog.setVisible = false;
    },
    // 统计图
    openViewDialog () {
      this.dialog.viewChartVisible = true;
    },
    closeViewChartVisible () {
      this.dialog.viewChartVisible = false;
    },
    // 重置
    ResetAssembly () {
      let that = this;
      this.$confirm({
        title: "是否确定要重置试卷？试题会被清空同时卷面设置会还原至系统默认",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk () {
          that.formData.exercisename = "请输入作业标题";
          that.pageList = [];
          localStorage.removeItem("localData");
          localStorage.removeItem("localJson");
          localStorage.removeItem("pageList");
          localStorage.removeItem("Title");
          window.history.go(-1);
        },
      });
    },
    goBack () {
      // window.location.router('/works/home')
      window.history.go(-1);
    },
  },
  updated () {
    if (window.MathJax) {
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
    }
    if (window.renderLatex) {
      if (this.$refs.contentQ)
        this.$refs.contentQ.forEach((q) => {
          window.renderLatex(q);
        });
    }
  },
  mounted () {
    const MathJax = document.createElement("script");
    MathJax.type = "text/javascript";
    MathJax.src =
      "https://mathjax.learnonly.com/MathJax.js?config=TeX-MML-AM_SVG";
    document.head.appendChild(MathJax);

    const MLCore = document.createElement("script");
    MLCore.type = "text/javascript";
    MLCore.src =
      "/resources/MLCore-2016.08.15.min.js?2019050809";
    document.head.appendChild(MLCore);

    this.state = this.$route.query.class;

    this.formData.struct = data.struct;
    this.localData = localStorage.getItem("localData");
    this.localJson = JSON.parse(localStorage.getItem("localJson"));
    if (localStorage.getItem("Title"))
      this.formData.exercisename = localStorage.getItem("Title");
    // if (JSON.parse(localStorage.getItem('localJson')) != null) {
    //     this.localJson = JSON.parse(localStorage.getItem('localJson'))
    // }
    // if (!JSON.parse(localStorage.getItem('pageList'))) {
    //     this.getQuesData()
    // } else if (JSON.parse(localStorage.getItem('pageList')).length != JSON.parse(localStorage.getItem('localJson')).length) {
    //     this.getQuesData()
    // } else {
    //     this.pageList = JSON.parse(localStorage.getItem('pageList'))
    //     this.totalizeScore(this.pageList)
    //     this.getQuesId(this.pageList)
    //     this.formData.bankid = this.pageList[0].bankId
    // }
    this.getQuesData();
    this.getWorktype()
  },
};
</script>

<style scoped>
/* @import '//netdna.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css'; */
.ass-box {
  width: 100%;
  height: auto;
  color: #333;
}
.ass-box .title {
  text-align: center;
  margin: 0 auto;
  padding-top: 20px;
}
.ass-box .title span {
  font-size: 20px;
  font-weight: bold;
}
.ass-box .title span:hover {
  color: #f00;
  cursor: pointer;
}
.ass-box ul {
  width: 100%;
  height: 100%;
  display: block;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
}
.ass-box ul li {
  display: block;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: auto;
  margin: 20px 0 30px;
  padding: 10px 20px 25px;
  /* background: #ecf4f8; */
  border: 1px solid #e5e5e5;
  cursor: pointer;
}

/deep/.dropdownDownload .ant-dropdown-menu-item {
  margin: 0 !important;
  padding: 10px 20px !important;
}

.ass-box ul li .index {
  position: absolute;
  top: 10px;
}
.ass-box ul li .info {
  /* border-top: 1px dashed #ddd; */
  padding: 8px 0;
  font-size: 13px;
}
.ass-box ul li .info span {
  line-height: 30px;
}
.ass-box ul li .info span {
  margin-right: 20px;
}
.ass-box ul li .info span i {
  color: #bfbcbc;
  padding: 0 3px;
}
.answer {
  border-top: 1px dashed #ddd;
  padding-top: 10px;
  font-size: 13px;
}
.answer p {
  margin-bottom: 5px;
}
/deep/.answer p span p {
  display: inline;
}
.ass-box ul li:hover .toolbar {
  display: block;
}
.ass-box ul li .toolbar {
  display: none;
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 25px;
  line-height: 25px;
  background: #307bc0;
  text-align: right;
}
.ass-box ul li .toolbar > a {
  color: #fff;
  margin-right: 15px;
  font-size: 12px;
  cursor: pointer;
}
.ass-box ul li .toolbar > a:not(:first-child):hover {
  text-decoration: underline;
}
.ass-box ul li .toolbar a input {
  height: 20px;
  font-size: 14px;
  background: none;
  border: none;
  border-bottom: 1px solid #fff;
  width: 25px;
  text-align: center;
}
.ass-box ul li .toolbar a input:focus {
  border: none;
}
.ass-box ul li .toolbar .scrollLine {
  background: none;
  color: #ccc;
  border: none;
  margin: 0 !important;
  margin-left: 45% !important;
  border-radius: 0;
  box-shadow: none;
  cursor: s-resize;
  float: left;
}
/* 效果图 */
.menu-item,
.menu-open-button {
  background: #4e639e;
  border-radius: 100%;
  width: 50px;
  height: 50px;
  margin-left: -100px;
  position: absolute;
  top: 20px;
  color: white;
  text-align: center;
  line-height: 50px;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  transition: -webkit-transform ease-out 200ms;
  transition: transform ease-out 200ms;
  transition: transform ease-out 200ms, -webkit-transform ease-out 200ms;
}

.menu-open {
  display: none;
}

.hamburger {
  width: 25px;
  height: 3px;
  background: white;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -12.5px;
  margin-top: -1.5px;
  transition: -webkit-transform 200ms;
  transition: transform 200ms;
  transition: transform 200ms, -webkit-transform 200ms;
}

.hamburger-1 {
  -webkit-transform: translate3d(0, -8px, 0);
  transform: translate3d(0, -8px, 0);
}

.hamburger-2 {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.hamburger-3 {
  -webkit-transform: translate3d(0, 8px, 0);
  transform: translate3d(0, 8px, 0);
}

.menu-open:checked + .menu-open-button .hamburger-1 {
  -webkit-transform: translate3d(0, 0, 0) rotate(45deg);
  transform: translate3d(0, 0, 0) rotate(45deg);
}
.menu-open:checked + .menu-open-button .hamburger-2 {
  -webkit-transform: translate3d(0, 0, 0) scale(0.1, 1);
  transform: translate3d(0, 0, 0) scale(0.1, 1);
}
.menu-open:checked + .menu-open-button .hamburger-3 {
  -webkit-transform: translate3d(0, 0, 0) rotate(-45deg);
  transform: translate3d(0, 0, 0) rotate(-45deg);
}

.menu {
  position: fixed;
  bottom: 200px;
  right: 40px;
  margin-left: 0;
  padding-top: 0;
  padding-left: 0;
  width: 0;
  height: 0;
  box-sizing: border-box;
  font-size: 20px;
  text-align: left;
  z-index: 999;
}

.menu-item:hover {
  background: #307bc0;
  color: #fff;
}
.menu-item:nth-child(3) {
  transition-duration: 180ms;
}
.menu-item:nth-child(4) {
  transition-duration: 180ms;
}
.menu-item:nth-child(5) {
  transition-duration: 180ms;
}
.menu-item:nth-child(6) {
  transition-duration: 180ms;
}
.menu-item:nth-child(7) {
  transition-duration: 180ms;
}
.menu-item:nth-child(8) {
  transition-duration: 180ms;
}
.menu-item:nth-child(9) {
  transition-duration: 180ms;
}

.menu-open-button {
  z-index: 2;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-duration: 400ms;
  -webkit-transform: scale(1.1, 1.1) translate3d(0, 0, 0);
  transform: scale(1.1, 1.1) translate3d(0, 0, 0);
  cursor: pointer;
}

.menu-open-button:hover {
  -webkit-transform: scale(1.2, 1.2) translate3d(0, 0, 0);
  transform: scale(1.2, 1.2) translate3d(0, 0, 0);
}

.menu-open:checked + .menu-open-button {
  transition-timing-function: linear;
  transition-duration: 200ms;
  -webkit-transform: scale(0.8, 0.8) translate3d(0, 0, 0);
  transform: scale(0.8, 0.8) translate3d(0, 0, 0);
}

.menu-open:checked ~ .menu-item {
  transition-timing-function: cubic-bezier(0.935, 0, 0.34, 1.33);
}
.menu-open:checked ~ .menu-item:nth-child(3) {
  transition-duration: 180ms;
  -webkit-transform: translate3d(0.08361px, -58.99997px, 0);
  transform: translate3d(0.08361px, -58.99997px, 0);
}
.menu-open:checked ~ .menu-item:nth-child(4) {
  transition-duration: 280ms;
  -webkit-transform: translate3d(60.9466px, 1.52414px, 0);
  transform: translate3d(60.9466px, 1.52414px, 0);
}
.menu-open:checked ~ .menu-item:nth-child(5) {
  transition-duration: 380ms;
  -webkit-transform: translate3d(0.9466px, 59.47586px, 0);
  transform: translate3d(0.9466px, 59.47586px, 0);
}
.menu-open:checked ~ .menu-item:nth-child(6) {
  transition-duration: 480ms;
  -webkit-transform: translate3d(-58.08361px, 1.99997px, 0);
  transform: translate3d(-58.08361px, 1.99997px, 0);
}
.menu-open:checked ~ .menu-item:nth-child(7) {
  transition-duration: 580ms;
  -webkit-transform: translate3d(-60.86291px, -15.62064px, 0);
  transform: translate3d(-60.86291px, -15.62064px, 0);
}
.menu-open:checked ~ .menu-item:nth-child(8) {
  transition-duration: 680ms;
  -webkit-transform: translate3d(-91.03006px, -52.33095px, 0);
  transform: translate3d(-91.03006px, -52.33095px, 0);
}
.menu-open:checked ~ .menu-item:nth-child(9) {
  transition-duration: 780ms;
  -webkit-transform: translate3d(-0.25084px, -104.9997px, 0);
  transform: translate3d(-0.25084px, -104.9997px, 0);
}
.anticon svg {
  font-size: 20px;
}

/deep/.ant-tooltip-inner {
  white-space: nowrap;
}
</style>
